/**
 * CostEstimator.config.js
 *
 * Static configuration for the Cost Estimator tool.
 * This file controls copy, defaults, and category-specific overrides.
 */

const CostEstimatorConfig = {
  id: "costEstimator",

  title: "Project Cost Estimator",

  description:
    "Answer four quick questions for your category to see a practical cost range and next steps.",

  ctaLabel: "Generate Estimate",

  resultSections: {
    estimate: {
      title: "Estimated Cost Range",
      disclaimer:
        "This estimate is based on the answers provided and is not a quote.",
    },
    nextSteps: {
      title: "Next Steps",
      description:
        "Local professionals can provide exact pricing based on your home and project details.",
    },
  },

  defaults: {
    zip: "",
    homeSize: "",
    projectScope: "",
    materialQuality: "",
  },

  /**
   * Category-specific overrides
   * These allow the same tool to feel tailored per category
   */
  categoryOverrides: {
    "bathroom-remodeling": {
      projectScopes: [
        { value: "basic", label: "Cosmetic refresh" },
        { value: "standard", label: "Standard remodel" },
        { value: "full", label: "Full renovation" },
      ],
    },

    "kitchen-cabinet-refacing": {
      projectScopes: [
        { value: "basic", label: "Door & drawer replacement" },
        { value: "standard", label: "Refacing + hardware" },
        { value: "full", label: "Full cabinet replacement" },
      ],
    },

    roofing: {
      projectScopes: [
        { value: "basic", label: "Minor repair" },
        { value: "standard", label: "Partial replacement" },
        { value: "full", label: "Full roof replacement" },
      ],
    },
  },

  materialQualities: [
    { value: "economy", label: "Economy" },
    { value: "midrange", label: "Mid-range" },
    { value: "premium", label: "Premium" },
  ],

  homeSizes: [
    { value: "small", label: "Under 1,500 sq ft" },
    { value: "medium", label: "1,500–2,500 sq ft" },
    { value: "large", label: "Over 2,500 sq ft" },
  ],
};

export default CostEstimatorConfig;
